import React from 'react'
import { DateTime } from 'luxon'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import CustomAvailabilityDestroyDialog from './custom-availability-destroy-dialog'

const formatTimeSlot = ts => {
  const start = DateTime.fromISO(ts.startTime).toFormat('h:mma')
  const end = DateTime.fromISO(ts.endTime).toFormat('h:mma')
  return `${start} - ${end}`
}

const CustomAvailabilityListItem = ({ override, onDestroySuccess }) => {
  const formattedDate = DateTime.fromISO(override.date).toFormat('MMM dd, yyyy')

  return (
    <Box mb={1.5}>
      <Card variant="outlined" style={{ position: 'relative' }}>
        <CardContent style={{ paddingBottom: '16px' }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={3}>
              <Typography style={{ fontWeight: 'bold' }}>
                {formattedDate}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" color="textSecondary">
                {override.coachFacility.name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              {override.timeSlots.map((ts, idx) => (
                <Typography key={idx} variant="body2">
                  {formatTimeSlot(ts)}
                </Typography>
              ))}
            </Grid>
          </Grid>
          <Box style={{ position: 'absolute', top: '8px', right: '16px' }}>
            <CustomAvailabilityDestroyDialog
              override={override}
              onSuccess={onDestroySuccess}
              trigger={
                <Box>
                  <IconButton aria-label="delete" style={{ padding: '8px' }}>
                    <DeleteOutlinedIcon />
                  </IconButton>
                </Box>
              }
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default CustomAvailabilityListItem
